module.exports = __webpack_public_path__ + "img/money-moon-join-header.8d4d0d77.svg";